import * as tslib_1 from "tslib";
import { StateObject } from "@hpcc-js/util";
import { WorkunitsService } from "../services/wsWorkunits";
var SourceFile = /** @class */ (function (_super) {
    tslib_1.__extends(SourceFile, _super);
    function SourceFile(optsConnection, wuid, eclSourceFile) {
        var _this = _super.call(this) || this;
        if (optsConnection instanceof WorkunitsService) {
            _this.connection = optsConnection;
        }
        else {
            _this.connection = new WorkunitsService(optsConnection);
        }
        _this.set(tslib_1.__assign({ Wuid: wuid }, eclSourceFile));
        return _this;
    }
    Object.defineProperty(SourceFile.prototype, "properties", {
        get: function () { return this.get(); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SourceFile.prototype, "Wuid", {
        get: function () { return this.get("Wuid"); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SourceFile.prototype, "FileCluster", {
        get: function () { return this.get("FileCluster"); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SourceFile.prototype, "Name", {
        get: function () { return this.get("Name"); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SourceFile.prototype, "IsSuperFile", {
        get: function () { return this.get("IsSuperFile"); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SourceFile.prototype, "Subs", {
        get: function () { return this.get("Subs"); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SourceFile.prototype, "Count", {
        get: function () { return this.get("Count"); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SourceFile.prototype, "ECLSourceFiles", {
        get: function () { return this.get("ECLSourceFiles"); },
        enumerable: true,
        configurable: true
    });
    return SourceFile;
}(StateObject));
export { SourceFile };
//# sourceMappingURL=sourceFile.js.map